"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../../schema");
const numberOfPregnancies = schema_1.Schema.number().integer().min(0).max(30);
const numberOfChildren = schema_1.Schema.number().integer().min(0).max(20);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ numberOfPregnancies, numberOfChildren })
    .interpretation({
    vocab: "ktx",
    code: "pregnancies_and_children_statement"
})
    .tag({ vocab: "fyrms", code: "action" });
